import React from 'react';

const Products = () => {
    return (
        <div>
            <h2>Lots of products here</h2>
        </div>
    );
};

export default Products;